import {
  ADD_TEXTBAUSTEIN,
  FETCH_TEXTBAUSTEINE,
  UPDATE_TEXTBAUSTEIN,
  DELETE_TEXTBAUSTEIN,
} from "./types";
import { simpleRequest } from "../newForms2/simpleRequest";

export function addTextbausteinOnAPI(data) {
  return async function (dispatch) {
    const response = await simpleRequest({
      url: `textbausteine`,
      method: "post",
      data,
    });
    console.log(response);
    console.log(response.data);
    const textbaustein = response.data && response.data.textbaustein;
    console.log({ textbaustein });
    return dispatch(addTextbaustein(textbaustein));
  };
}
function addTextbaustein(textbaustein) {
  return {
    type: ADD_TEXTBAUSTEIN,
    textbaustein,
  };
}

export function fetchTextbausteineFromAPI() {
  return async function (dispatch) {
    const data = (await simpleRequest({ url: `textbausteine`, method: "get" }))
      .data;
    const textbausteine = data?.textbausteine;
    return dispatch(getTextbausteine(textbausteine));
  };
}
function getTextbausteine(textbausteine) {
  return {
    type: FETCH_TEXTBAUSTEINE,
    textbausteine,
  };
}

export function updateTextbausteinOnAPI(id, data) {
  return async function (dispatch) {
    const response = await simpleRequest({
      url: `textbausteine/${id}`,
      method: "patch",
      data,
    });
    const textbaustein = response.data && response.data?.textbaustein;
    return dispatch(updateTextbaustein(textbaustein));
  };
}
function updateTextbaustein(textbaustein) {
  return {
    type: UPDATE_TEXTBAUSTEIN,
    textbaustein,
  };
}

export function deleteTextbausteinFromAPI(id) {
  return async function (dispatch) {
    const response = await simpleRequest({
      url: `textbausteine/${id}`,
      method: "delete",
    });
    const deleted = response.data?.deleted;
    return dispatch(deleteTextbaustein(deleted));
  };
}
function deleteTextbaustein(deleted) {
  return {
    type: DELETE_TEXTBAUSTEIN,
    deleted,
  };
}
